// ── ORDERS ────────────────────────────────────────────────────
import {useEffect, useState} from "react";
import {getOrders, updateOrder} from "../../../api/api";
import {CrudTable} from "../crud_tables/crud_tables";
import {API_URL} from "../../../constants/constants";
import {useTranslation} from "react-i18next";

export const OrdersSection = () => {
    const [orders, setOrders] = useState<any[]>([]);
    const [selected, setSelected] = useState<any>(null);
    const {t} = useTranslation()

    useEffect(() => { getOrders().then(setOrders).catch(console.error); }, []);

    const updateStatus = async (id: number, status: string) => {
        await updateOrder(id, status);
        getOrders().then(setOrders)
    };

    return (
        <div>
            <div className="admin-card">
                <CrudTable
                    cols={['id', 'customerName', 'customerPhone', 'total', 'status', 'createdAt']}
                    rows={orders}
                    onEdit={row => setSelected(selected?.id === row.id ? null : row)}
                />
            </div>
            {selected && (
                <div className="admin-card">
                    <p>
                        {t("admin.orders.order")} #{selected.id} - {selected.customerName}
                    </p>
                    <div>
                        {['pending', 'confirmed', 'shipped', 'delivered'].map(s => (
                            <button
                                key={s}
                                className={`btn-admin ${selected.status === s ? 'btn-admin-primary' : 'btn-admin-secondary'}`}
                                onClick={() => updateStatus(selected.id, s)}
                            >
                                {s}
                            </button>
                        ))}
                    </div>
                    <table className="admin-table">
                        <thead>
                        <tr>
                            <th>{t("admin.orders.product")}</th>
                            <th>{t("admin.orders.image")}</th>
                            <th>{t("admin.orders.price")}</th>
                            <th>{t("admin.orders.quantity")}</th>
                            <th>{t("admin.orders.sub-total")}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {selected.items?.map((item: any) => (
                            <tr key={item.id}>
                                <td>{item.product?.name || `#${item.productId}`}</td>
                                <td>{item.product?.imageUrl && <img src={`${API_URL}${item.product.imageUrl}`} alt="" />}</td>
                                <td>{item.product?.price} €</td>
                                <td>{item.qty}</td>
                                <td>{(item.product?.price * item.qty).toFixed(2)} €</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};
